import { useContext } from 'react'

import { TrackingContext, ITrackingContext } from '@providers/trackingProvider'

export default function useTracking(): ITrackingContext {
  const { PushMessage } = useContext(TrackingContext)

  return { PushMessage }
}
